import { React, useEffect, useState, useRef, useLayoutEffect } from 'react';
import { GoogleMap, LoadScript, Data, DrawingManager, Circle, Polygon, LatLngBounds } from '@react-google-maps/api';
//https://react-google-maps-api-docs.netlify.app/
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Skeleton from '@mui/material/Skeleton';
import TokenService from '../../services/TokenService'
import IconButton from '@mui/material/IconButton';
import { useSnackbar } from 'notistack';
import Button from '@mui/material/Button';
import MapIcon from '@mui/icons-material/Map';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import AddLocationIcon from '@mui/icons-material/AddLocation';
import WrongLocationIcon from '@mui/icons-material/WrongLocation';
import BlockIcon from '@mui/icons-material/Block';
import Fab from '@mui/material/Fab';
import AddZipcode from '../Modals/AddZipcode';
import ViewZipcodeBoundry from '../Modals/ViewZipcodeBoundry';
import ConfirmDialog from '../Modals/ConfirmDialog';
import styles from './MyAccount.module.css'; // Import css modules stylesheet as styles
import DrawableMap from './DrawableMap'
const drawingLibraries = ['drawing']; // keep outside of component so it doesn't cause the map to re-render



function AdvancedServiceAreas(props) {
    
    const GOOGLE_MAPS_API_KEY = 'AIzaSyDqNnSuRDD3nyJ-oVOY4jV7McgqBIDyId0';
    const parentContainerRef = useRef();
    const mapControl = useRef();
    let addingShape = null;
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
    const [serviceAreas, setserviceAreas] = useState([]);
    const center = { // default if no location is known (Founder's Brewery, obviously)
        lat: 42.958261,
        lng: -85.6739641
    };
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const metersPerMile = 1609.34;
    const [isDrawing, setIsDrawing] = useState(false);
    const [viewingServiceArea, setViewingServiceArea] = useState(null);
    const [mapComponent, setMapComponent] = useState(null); 
    useEffect(() => {
        if (props.loggedInUser !== null && props.loggedInUser !== undefined) {
            // first load
            buildShapes();
        }
    },[]);

    useEffect(() => {
        if (props.loggedInUser !== null && props.loggedInUser !== undefined) {
            // props changed
            buildShapes();
        }
    }, [props]);

    useLayoutEffect(() => {
        if (parentContainerRef.current) {
            setDimensions({
                width: parentContainerRef.current.offsetWidth,
                height: parentContainerRef.current.offsetHeight
            });
        }
    }, []);

    function handleShapeClick(mouseEvent) {
        //console.log('handleShapeClick');
        if (mouseEvent !== null) {
            setViewingServiceArea(this.ServiceArea);
            
        }
    }

    function buildShapes() {
        let currentAreas = [];
        let bounds = {
            north: 0,
            east: 0,
            south: 0,
            west:0
        }
       // let bounds = LatLngBounds
        for (let i = 0; i < props.loggedInUser.ServiceAreas.length; i++) {
            if (props.loggedInUser.ServiceAreas[i].AreaType == 1 &&
                props.loggedInUser.ServiceAreas[i].Geography != null &&
                props.loggedInUser.ServiceAreas[i].Geography.length > 0) {
                // zipcode shape
                for (let shapeCount = 0; shapeCount < props.loggedInUser.ServiceAreas[i].Geography.length; shapeCount++) {
                    currentAreas.push(<Polygon key={'Shape_' + props.loggedInUser.ServiceAreas[i].ServiceAreaId + '_' + shapeCount}
                        paths={props.loggedInUser.ServiceAreas[i].Geography[shapeCount].Points}
                        onClick={handleShapeClick}
                        options={{
                            strokeColor: '#0000FF',
                            strokeOpacity: 0.8,
                            strokeWeight: 2,
                            fillColor: '#0000FF',
                            fillOpacity: 0.35,
                            clickable: true,
                            draggable: false,
                            editable: false,
                            visible: true,
                            geodesic: false,
                            zIndex: 1,
                            ServiceArea: props.loggedInUser.ServiceAreas[i]
                        }}
                    />);
                }

                //item = new google.maps.Polygon({
                //    paths: shapeCoords.Points,
                //    strokeColor: "#0000FF",
                //    strokeOpacity: 0.6,
                //    strokeWeight: 1,
                //    fillColor: "#0000FF",
                //    fillOpacity: 0.35,
                //    returnerId: serviceArea.ReturnerId, // no longer used
                //    ServiceAreaId: serviceArea.ServiceAreaId,// no longer used
                //    returnerIds: [serviceArea.ReturnerId],
                //    serviceAreaIds: [serviceArea.ServiceAreaId],
                //    zipcode: serviceArea.Zipcode
                //});
            }
            else if (props.loggedInUser.ServiceAreas[i].AreaType == 2) {
                // circles
                currentAreas.push(<Circle key={'Shape_' + props.loggedInUser.ServiceAreas[i].ServiceAreaId}
                    center={{
                        lat: props.loggedInUser.ServiceAreas[i].Latitude, lng: props.loggedInUser.ServiceAreas[i].Longitude
                    }}
                    onClick={handleShapeClick}
                    // required
                    options={{
                        strokeColor: '#0000FF',
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: '#0000FF',
                        fillOpacity: 0.35,
                        clickable: true,

                        draggable: false,
                        editable: false,
                        visible: true,
                        radius: props.loggedInUser.ServiceAreas[i].RadiusMiles * metersPerMile,
                        zIndex: 1,
                        ServiceArea: props.loggedInUser.ServiceAreas[i]
                    }}
                />
                )
            }
        }
        setserviceAreas(currentAreas);
    }

    function buildViewingServiceAreaDialog() {
        let title = '';
        let message = '';
        if (viewingServiceArea.AreaType == 1) {
            title = 'Zip Code ' + viewingServiceArea.Zipcode;
            message = <div>Do you want to delete this zip code from your service area?</div>
        }
        else {
            title = 'Area of ' + Math.floor(viewingServiceArea.RadiusMiles * viewingServiceArea.RadiusMiles * 3.14) + ' sq miles'
            message = <div>Do you want to delete this circle area from your service area?</div>
        }

        

        return <ConfirmDialog
            Close={handleViewServiceAreaPromptClosed}
            Title={title}
            CancelText='Cancel'
            AcceptText='Delete'
            Content={message}
            Data={viewingServiceArea } />
        
            
    }

    function handleViewServiceAreaPromptClosed(isDeleted, serviceArea) {
        if (isDeleted) {
            let postData = {
                serviceAreaId: serviceArea.ServiceAreaId
            }

            TokenService.post(postData, 'DeleteServiceArea')
                .then((response) => {
                    response = response[Object.keys(response)[0]];
                    if (response.Result == "SUCCESS") {

                        // response is the deleted service area
                        for (let i = 0; i < props.loggedInUser.ServiceAreas.length; i++) {
                            if (response.ServiceAreaId === props.loggedInUser.ServiceAreas[i].ServiceAreaId) {
                                // remove this servicearea
                                props.loggedInUser.ServiceAreas.splice(i, 1);
                                break;
                            }
                        }
                        props.onChange(props.loggedInUser);
                        let jsonData = JSON.parse(response.JsonData);
                        let level = JSON.parse(jsonData.ReturnerLevel);
                        let event = new CustomEvent('ReturnerLevel_Updated', {
                            detail: level
                        });
                        document.getElementsByTagName('body')[0].dispatchEvent(event);
                    }
                })
                .catch((response) => {
                    enqueueSnackbar('Oops, something went wrong', {
                        variant: 'error',
                    });
                });
        }
        setViewingServiceArea(null);
    }

    function onCircleComplete(drawnCircle) {
        if (onCircleComplete !== null) {
            let radiusMiles = drawnCircle.radius / metersPerMile;
            if (radiusMiles * radiusMiles * 3.14 > 1000) {
                drawnCircle.setMap(null);
                enqueueSnackbar('This area is ' + Math.floor(radiusMiles * radiusMiles * 3.14) + ' square miles. The Max size is 1,000 square miles', {
                    variant: 'error',
                });
            }
            else {
      
                addingShape = drawnCircle; // save for removing from map later
                let postData = {
                    serviceArea : {
                        ServiceAreaId: 0,
                        ReturnerId: 0,
                        AreaType: 2,
                        Zipcode: "",
                        RadiusMiles: radiusMiles,
                        Latitude: drawnCircle.center.lat(),
                        Longitude: drawnCircle.center.lng(),
                        Latitude2: 0,
                        Longitude2: 0
                    }
                }
                
                TokenService.post(postData, 'AddServiceArea')
                    .then((response) => {
                        response = response[Object.keys(response)[0]];
                        if (response.Result == "SUCCESS") {

                            // response is the deleted service area
                            props.loggedInUser.ServiceAreas.push(response);
                            props.onChange(props.loggedInUser);
                        }
                        if (addingShape !== null) {
                            addingShape.setMap(null);
                            addingShape = null;
                        }
                        let jsonData = JSON.parse(response.JsonData);
                        let level = JSON.parse(jsonData.ReturnerLevel);
                        let event = new CustomEvent('ReturnerLevel_Updated', {
                            detail: level
                        });
                        document.getElementsByTagName('body')[0].dispatchEvent(event);
                    })
                    .catch((response) => {
                        enqueueSnackbar('Oops, something went wrong', {
                            variant: 'error',
                        });
                    });


            }
            
        }
        setIsDrawing(false);
    }

    return (
        <div ref={parentContainerRef}>
            <div style={{ display: 'flex', justifyContent:'space-between', marginTop:'3px', marginBottom:'3px' }}>
                <div style={{ alignSelf: 'center', fontSize: '10pt' }}>
                    {isDrawing?
                    'Click and drag to add a Service Area'
                    :
                    'Click Add to create a new Service Area'
                    }
                </div>

                <Fab aria-label="More Info" onClick={() => setIsDrawing(!isDrawing)} style={{ minWidth: '45px', width: '45px', height: '45px', alignSelf: 'center' }}>
                    {isDrawing ?
                        <BlockIcon sx={{ color: 'var(--sipzee-red)', fontSize: 40 }} />
                        :

                        <AddLocationIcon sx={{ color: 'var(--sipzee-green)', fontSize: 40 }} />
                    }
                </Fab>
            </div>

            <LoadScript
            googleMapsApiKey={GOOGLE_MAPS_API_KEY}
            libraries={drawingLibraries}
            >
            <DrawableMap
                width={dimensions.width}
                center={center}
                isDrawing={isDrawing}
                onCircleComplete={onCircleComplete}
                serviceAreas={serviceAreas }
                />
            </LoadScript>
            {viewingServiceArea === null ?
                null
                :
                buildViewingServiceAreaDialog()
            }
           
        </div>
    );
}
export default AdvancedServiceAreas;